import { useEffect, useState } from 'react';

import Loading from 'Components/Lib/Elements/Loading';
import loadJsonData from '../Utils/loadJsonData';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import { useSearchParams } from 'react-router-dom';
import Table from '../Elements/Table';

export interface IDashboardProperties {
    Listtype: 'mytasks' | 'appointments';
    designer: any;
}

interface IListItems {
    Time?: string;
    ListItemName?: string;
    Action?: string;
    Tasknumber?: string | number;
    Taskdesc?: string;
}

/**
 * Renderes a List
 * @param {any} props Properties given by the caller
 * @returns {JSX.Element} Rendered Element.
 */
function ItemStockPositionsView(props: any): JSX.Element {
    const [loading, setLoading] = useState(true); // eslint-disable-line
    const [data, setData] = useState(null as any);

    //getParams
    const [searchParams, setSearchParams] = useSearchParams();
    let index = searchParams.get('index');
    let customerId = searchParams.get('customer');

    useEffect(() => {
      setLoading(true);

      if(index) {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetItem + index).then((data:any) => {
            if (data.Meta.Success && data.Data && data.Data.Stock) {
                setData(data.Data.Stock);
                setLoading(false);
            }
        });
    }else {
        setLoading(false);
    }
    },[setLoading]);
    console.log(data);
    return (
        <>
                <div className="mfx-view">
                    {loading && <Loading />}
                    {!loading && data && data?.length > 0 && 
                    <div style={{paddingTop: '2.5rem'}}>
                    <Table
                        data={data}
                        states={{disableMode:true}}
                        type={'ITEMSTOCKPOSITIONS'}
                        designer={props.designer}
                    />
                    </div>

                    } 
                </div>

                {!loading && data && data.length === 0 && (
                    <h4 className="nothing-found">
                        {window.Dictionary.getTranslation(14342)} <i className="icon-search"></i>
                    </h4>
                )}
        
        </>
    );
}

export default ItemStockPositionsView;
